import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'title' },
  { name: 'all' },
  { name: 'author' },
  { name: 'abstract' },
  { name: 'comments' },
  { name: 'journal_ref' },
  { name: 'acm_class' },
  { name: 'msc_class' },
  { name: 'report_num' },
  { name: 'paper_id' },
  { name: 'doi' },
  { name: 'orcid' },
  { name: 'author_id' },
  { name: 'help' },
  { name: 'full_text' },
  { name: 'date-from_date' },
  { name: 'date-to_date' }
]

class ArxivEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('arXiv')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
  }
  formTerm (text, addQuotes) {
    let r = ''
    if (addQuotes) {
      r += '"'
    }
    r += text
    if (addQuotes) {
      r += '"'
    }
    return encodeURIComponent(r)
  }
  formulateClauseFieldPart (index, operator, fieldSpecifier, term) {
    if (fieldSpecifier === 'date-from_date' || fieldSpecifier === 'date-to_date') {
      return `&${fieldSpecifier}=${term}`
    } else {
      return `&terms-${index}-operator=${operator}&terms-${index}-field=${fieldSpecifier || 'all'}&terms-${index}-term=${term}`
    }
  }
  formulateQueryFromNodeData (nodeData) {
    const baseTerm = nodeData.text.replace(SearchEngine.quoteReplaceRE, '\\"')
    const addQuotes = this.addQuotesAroundPhrases && baseTerm && baseTerm.indexOf(' ') > 0
    const term = this.formTerm(baseTerm, addQuotes)
    return this.formulateClauseFieldPart(0, nodeData.isNegative ? 'AND' : 'NOT', nodeData.fieldSpecifier, term)
  }
  formulateQueryFromTreeDataInternal (treeData, parentFieldSpecifier) {
    if (typeof treeData.children === 'undefined') {
      return this.formTerm(treeData.text)
    }
    let r = ''
    const thisOperator = treeData.operator || 'AND'
    const mappedThisOperator = this.mapOperator(thisOperator)
    let index = 0
    for (const i of treeData.children) {
      if (i.isOperator || i.children) {
        continue
      }
      let fieldSpecifier = null
      if (i.fieldSpecifier) {
        fieldSpecifier = i.fieldSpecifier
      } else if (parentFieldSpecifier) {
        fieldSpecifier = parentFieldSpecifier
      }
      // Ignores children as there's no way to provide nested elements to arXiv.
      r += this.formulateClauseFieldPart(index, i.isNegative ? 'NOT' : mappedThisOperator.op, fieldSpecifier, this.formTerm(i.text, this.addQuotes(i)))
      index++
    }
    return r
  }
  formulateQuery (query) {
    return 'https://arxiv.org/search/advanced?advanced=' + query
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    const r = m ? [m] : []
    if (typeof queryGraphData.children !== 'undefined') {
      let showWarning = false
      for (const i of queryGraphData.children) {
        if (i.children && i.children.length > 0) {
          showWarning = true
        }
      }
      if (showWarning) {
        r.push(this.formatErrorMessage('oneLevelNesting'))
      }
    }
    return r
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default ArxivEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/ArxivEngine.js